import { defineComponent as _, ref as m, watch as b, resolveComponent as l, createElementBlock as n, openBlock as s, createVNode as c, withCtx as v, createElementVNode as i, renderSlot as g, Fragment as h, renderList as w, normalizeClass as k, createCommentVNode as C, toDisplayString as P } from "vue";
import { v as $ } from "./vsCard-CgHEnE92.mjs";
import { v as I } from "./vsIcon-Cyr63bPF.mjs";
import { v as D } from "./vsButton-BlFL21k0.mjs";
import { _ as x } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const B = _({
  name: "vs-toolbar",
  components: {
    vsCard: $,
    vsButton: D,
    vsIcon: I
  },
  props: {
    pages: {
      type: Object,
      default: () => []
    },
    activePage: { type: String, default: "" },
    compact: { type: Boolean, default: !1 }
  },
  emits: ["page:select"],
  setup(e, { emit: d }) {
    const r = m(e.activePage);
    b(() => e.activePage, (t) => {
      t !== "" && (r.value = t);
    });
    const u = (t) => t.findIndex((a) => a.id === r.value) >= 0, f = m(null);
    return { emit: d, selectedPageID: r, toolbar: f, isActiveSection: u };
  }
}), S = { class: "block w-full" }, j = { class: "flex justify-around w-full p-1" }, z = { class: "relative" }, N = {
  key: 0,
  class: "w-4 h-4 bg-error-400 rounded-full absolute -top-2 -left-2"
};
function V(e, d, r, u, f, t) {
  const a = l("vs-icon"), p = l("vs-button"), y = l("vs-card");
  return s(), n("div", S, [
    c(y, {
      class: "relative overflow-y-auto h-z-1 !py-0 !px-0 z-10 bg-gradient-to-tr from-primary-400 to-primary-800 min-w-[90px] h-full",
      ref: "toolbar",
      "padding-value": 2,
      "rounded-t-l": !1,
      "rounded-b-l": !1,
      "rounded-t-r": !1,
      "rounded-b-r": !1
    }, {
      default: v(() => [
        i("div", j, [
          (s(!0), n(h, null, w(e.pages, (o) => (s(), n("div", {
            key: o.id,
            class: "flex-grow"
          }, [
            c(p, {
              kind: "flat",
              class: k(`justify-center h-10 w-full text-on-primary outline-secondary hover:bg-opacity-40 hover:bg-on-primary !overflow-visible ${e.selectedPageID === o.id ? "!bg-gradient-to-bl from-primary-400 to-secondary-300 text-on-secondary shadow-lg shadow-secondary/50 rounded-full" : ""}`),
              onClick: (E) => {
                e.selectedPageID = o.id, e.emit("page:select", o);
              }
            }, {
              after: v(() => [
                i("div", z, [
                  o.alert ? (s(), n("div", N)) : C("", !0),
                  c(a, {
                    name: o.icon,
                    class: "mr-0",
                    color: "on-primary"
                  }, null, 8, ["name"])
                ]),
                i("div", null, P(e.selectedPageID === o.id && !e.compact ? o.name : ""), 1)
              ]),
              _: 2
            }, 1032, ["class", "onClick"])
          ]))), 128)),
          g(e.$slots, "default")
        ])
      ]),
      _: 3
    }, 512)
  ]);
}
const q = /* @__PURE__ */ x(B, [["render", V]]);
export {
  q as v
};
//# sourceMappingURL=vsToolbar-C_u0GSp3.mjs.map
